import React, {Component} from 'react';
import {Link} from 'react-router';

class Email extends Component {
  constructor(props) {
    super(props);

    let storageState = {};
    if (localStorage.nonWinner && localStorage.nonWinner !== 'undefined') {
      storageState.nonWinner = localStorage.nonWinner;
    }
    if (localStorage.fillColor && localStorage.fillColor !== 'undefined') {
      storageState.fillColor = localStorage.fillColor;
    }
    if (localStorage.borderColor && localStorage.borderColor !== 'undefined') {
      storageState.borderColor = localStorage.borderColor;
    }
    if (localStorage.buttonFontColor && localStorage.buttonFontColor !== 'undefined') {
      storageState.buttonFontColor = localStorage.buttonFontColor;
    }
    if (localStorage.fontTopPadding && localStorage.fontTopPadding !== 'undefined') {
      storageState.fontTopPadding = localStorage.fontTopPadding;
    }
    if (localStorage.fontBottomPadding && localStorage.fontBottomPadding !== 'undefined') {
      storageState.fontBottomPadding = localStorage.fontBottomPadding;
    }
    if (localStorage.fontLeftPadding && localStorage.fontLeftPadding !== 'undefined') {
      storageState.fontLeftPadding = localStorage.fontLeftPadding;
    }
    if (localStorage.fontRightPadding && localStorage.fontRightPadding !== 'undefined') {
      storageState.fontRightPadding = localStorage.fontRightPadding;
    }
    if (localStorage.fontColor && localStorage.fontColor !== 'undefined') {
      storageState.fontColor = localStorage.fontColor;
    }
    if (localStorage.emailHeaderText && localStorage.emailHeaderText !== 'undefined') {
      storageState.emailHeaderText = localStorage.emailHeaderText;
    }
    if (localStorage.emailPrePromptText && localStorage.emailPrePromptText !== 'undefined') {
      storageState.emailPrePromptText = localStorage.emailPrePromptText;
    }
    if (localStorage.emailPostPromptText && localStorage.emailPostPromptText !== 'undefined') {
      storageState.emailPostPromptText = localStorage.emailPostPromptText;
    }
    if (localStorage.termsAndConditions && localStorage.termsAndConditions !== 'undefined') {
      storageState.termsAndConditions = localStorage.termsAndConditions;
    }
    if (localStorage.termsAndConditionsCopy && localStorage.termsAndConditionsCopy !== 'undefined') {
      storageState.termsAndConditionsCopy = localStorage.termsAndConditionsCopy;
    }
    if (localStorage.termsAndConditionsLink && localStorage.termsAndConditionsLink !== 'undefined') {
      storageState.termsAndConditionsLink = localStorage.termsAndConditionsLink;
    }

    this.state = {
      nonWinner: false,
      fillColor: null,
      borderColor: null,
      buttonFontColor: null,
      fontTopPadding: null,
      fontBottomPadding: null,
      fontLeftPadding: null,
      fontRightPadding: null,
      fontColor: null,
      emailHeaderText: null,
      emailPrePromptText: null,
      emailPostPromptText: null,
      termsAndConditions: null,
      termsAndConditionsCopy: null,
      termsAndConditionsLink: null,
      ...storageState
    };
    this.validateEmail = this.validateEmail.bind(this);
  }

  validateEmail(e) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(e).toLowerCase());
  }

  render() {
    //console.log('state: ', this.state, 'props: ', this.props);
    const next = this.props.route.next || this.props.location.state.next
    const nextScreen = this.props.route.nextScreen;

    const nonWinner = this.state.nonWinner == 'true' ? true : false;
    const fillColor =
      this.state.fillColor === 'null' ? null : this.state.fillColor;
    const borderColor = this.state.borderColor;
    const buttonFontColor = this.state.buttonFontColor;
    const fontColor = this.state.fontColor;
    const emailHeaderText = this.state.emailHeaderText;
    const emailPrePromptText = this.state.emailPrePromptText;
    const emailPostPromptText = this.state.emailPostPromptText;
    const termsAndConditions = this.state.termsAndConditions == 'true' ? true : false;
    const termsAndConditionsCopy = this.state.termsAndConditionsCopy;
    const termsAndConditionsLink = this.state.termsAndConditionsLink;

    const buttonTopPadding = 0 + Number(this.state.fontTopPadding);
    const buttonBottomPadding = 0 + Number(this.state.fontBottomPadding);
    const buttonLeftPadding = 60 + Number(this.state.fontLeftPadding);
    const buttonRightPadding = 60 + Number(this.state.fontRightPadding);
    const fontTopPadding = 0 + Number(this.state.fontTopPadding);
    const fontBottomPadding = 0 + Number(this.state.fontBottomPadding);
    const fontLeftPadding = 0 + Number(this.state.fontLeftPadding);
    const fontRightPadding = 0 + Number(this.state.fontRightPadding);

    //console.log('state: ', this.state);

    let continueButton;
    if(this.validateEmail(this.state.email)) {
        continueButton = (
            <Link className="genericBtn"
                to={{pathname: next}}
                onClick={() => {
                    if (this.validateEmail(this.state.email)) {
                        localStorage.setItem('email', this.state.email);
                        this.props.router.push(next);
                    }
                }}
                style={{
                  color: buttonFontColor || 'white',
                  background: fillColor || 'grey',
                  borderColor: borderColor || 'red',
                  padding: buttonTopPadding + 'px ' + buttonRightPadding + 'px ' + buttonBottomPadding + 'px ' + buttonLeftPadding + 'px'
                }}>
                Continue
            </Link>
        );
    } else {
        continueButton = (
            <Link className="genericBtn"
                style={{
                  color: buttonFontColor || 'white',
                  background: fillColor || 'grey',
                  borderColor: borderColor || 'red',
                  padding: buttonTopPadding + 'px ' + buttonRightPadding + 'px ' + buttonBottomPadding + 'px ' + buttonLeftPadding + 'px'
                }}>
                Continue
            </Link>
        );
    }

    let inputStyle={
      borderStyle: 'solid',
      borderRadius: '5px',
      width: '100%',
      height: '3.3em',
      marginBottom: '2em'
    };
    if(this.validateEmail(this.state.email)) {
      inputStyle.borderColor = borderColor;
    } else {
      delete inputStyle.borderColor;
    }

    return (
      <div className="genericAppInner">
        <div id="intro" className="page">
          <div className="verticalWrap contentWrap">
            <div className="genericInnerWrap">
              <h1
                className="congrats"
                style={{
                  borderBottomColor: fontColor,
                  padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                }}
              >
                {emailHeaderText}
              </h1>
              <h3
                className="topSpace emailText"
                style={{
                  padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                }}
              >
                {emailPrePromptText}
              </h3>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  if (this.validateEmail(this.state.email)) {
                    localStorage.setItem('email', this.state.email);
                    this.props.router.push(next);
                  }
                }}>
                <input
                  placeholder="Enter email address here..."
                  onChange={e => {
                    this.setState({email: e.target.value});
                  }}
                  onFocus={() => {
                    document.getElementById('continue').style.zIndex = "-1";
                  }}
                  onBlur={() => {
                    document.getElementById('continue').style.zIndex = "1";
                  }}
                   className={
                    this.validateEmail(this.state.email)
                      ? 'validEmail'
                      : 'invalidEmail'
                  }
                  style={inputStyle}
                  type="text"
                  name="name"
                />
                <br />
                {
                  //<input type="submit" value="Submit" />
                }
              </form>
              <div>
                <h3
                  className="topSpace emailText"
                  style={{
                    padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                  }}
                >
                  {emailPostPromptText}
                </h3>
                <div id="continue" className="continue">
                  {continueButton}
                  {termsAndConditions && (
                    <div className="termsAndConditions">
                      <h1>{termsAndConditionsCopy}</h1>
                      <a href={termsAndConditionsLink}>TERMS &amp; CONDITIONS</a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Email;



// WEBPACK FOOTER //
// ./src/components/Email.js